export default {"src":"/_next/static/media/bg-square.45fa56fb.svg","height":227,"width":227};